module.exports = __webpack_public_path__ + "img/1528125048.d3c4f12e.jpg";